export default __webpack_public_path__ + "static/media/lettuce.59d071fe.svg";